var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info",
    clipPath: "url(#clip0_2066_776)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 2.41667C6.48 2.41667 2 6.71 2 12C2 17.29 6.48 21.5833 12 21.5833C17.52 21.5833 22 17.29 22 12C22 6.71 17.52 2.41667 12 2.41667ZM12 16.7917C11.45 16.7917 11 16.3604 11 15.8333V12C11 11.4729 11.45 11.0417 12 11.0417C12.55 11.0417 13 11.4729 13 12V15.8333C13 16.3604 12.55 16.7917 12 16.7917ZM13 9.125H11V7.20833H13V9.125Z",
    fill: "#121212"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2066_776"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 23,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.23d3e4e3360451e069098249ec0430c1.svg";
export { ForwardRef as ReactComponent };